// Determine if the toggle button value matches, or is contained in, the
// candidate group value.
export default function isValueSelected(value, candidate) {
  if (candidate === undefined || value === undefined) {
    return false;
  }

  if (Array.isArray(candidate)) {
    return candidate.indexOf(value) >= 0;
  }

  return value === candidate;
}


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/lab/esm/ToggleButtonGroup/isValueSelected.js
// module id = 7360
// module chunks = 2